import React, { useState, useEffect } from "react";
import Ripples from "react-ripples"; // Importamos el componente
import slider1 from "../assets/img/slider1.jpeg"; // Imagen 1
import slider2 from "../assets/img/slider2.jpeg"; // Imagen 2
import slider3 from "../assets/img/slider3.jpeg"; // Imagen 3

const HeroTheme = () => {
  const slides = [
    {
      image: slider1,
      title: "!Hoy Vemos!",
      description: [
        " Plataforma de streaming para Android",
      ],
      buttonText: "Comenzar",
      buttonLink: "#explorar",
    },
    {
      image: slider2,
      title: "Sin anuncios",
      description: [
        "Disfruta de una experiencia de visualización fluida",

      ],
      buttonText: "Comenzar",
      buttonLink: "#programacion",
    },
    {
      image: slider3,
      title: "Inspírate",
      description: [
        "Amplia biblioteca de contenido",
      ],
      buttonText: "Comenzar",
      buttonLink: "#comenzar",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Autoslider functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Cambiar cada 5 segundos
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          {/* Content */}
          <div className="relative z-20 flex flex-col items-center justify-center h-full text-center text-white px-6 max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">{slide.title}</h1>
            {slide.description.map((text, idx) => (
              <p key={idx} className="text-lg md:text-xl mb-4">
                {text}
              </p>
            ))}
            <Ripples color="rgba(255, 255, 255, 0.3)" during={400}>
              <a
                href={slide.buttonLink}
                className="inline-block bg-[#1d4ed8] hover:bg-[#2563eb] text-white py-2 px-6 rounded-md text-lg font-medium transition-all shadow hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
              >
                {slide.buttonText}
              </a>
            </Ripples>
          </div>
        </div>
      ))}

      {/* Navigation Dots */}
      <div className="absolute bottom-6 flex space-x-2 justify-center z-30">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full ${
              index === currentSlide
                ? "bg-white"
                : "bg-gray-400 hover:bg-gray-300"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default HeroTheme;
